import { IProductSeoLocale, IUpdateProductSeoDTO } from '@/models/products.model';
import { ProductSeoFormFieldsNames, TProductSeoFormValues } from '../helpers';
import { SupportedLocales } from '@/models/localization.model';

class UpdateProductSeoDTO implements IUpdateProductSeoDTO {
  locale: { [key in SupportedLocales]: IProductSeoLocale };

  constructor(values: TProductSeoFormValues) {
    this.locale = {} as { [key in SupportedLocales]: IProductSeoLocale };

    Object.entries(values[ProductSeoFormFieldsNames.LOCALE]).forEach(([locale, fields]) => {
      this.locale[locale as SupportedLocales] = {
        ...fields,
        seo_keywords: fields.seo_keywords.join(','),
      };
    });
  }
}

export default UpdateProductSeoDTO;
